import React from "react";

import getProductName from "@helpers/products/getProductName";

import type { Product } from "@typings/product/product";
import classNames from "classnames";

interface CartItemHeaderProps {
  cartItem: Product;
  redirectToProductPage: () => void;
}

const CartItemHeader = ({ cartItem, redirectToProductPage }: CartItemHeaderProps) => {
  const { item, configuration } = cartItem;
  const { quantity, price, oldPrice } = configuration;

  return (
    <div className="cart-item__header">
      <div className="cart-item__title">
        <button
          className={classNames("cart-item__name", { "cursor-default": price === 0 })}
          type="button"
          onClick={redirectToProductPage}
        >
          {cartItem.item.name}
        </button>
        <div className="cart-item__total">
          {item.category.name === "Free Gift" ? (
            <div className="cart-item__total-price__wrapper">
              <span className="cart-item__total-quantity">{quantity} x </span>
              <span className="cart-item__total-price">FREE</span>
            </div>
          ) : (
            <React.Fragment>
              <div className="cart-item__total-price__wrapper">
                <span className="cart-item__total-quantity">{quantity} x </span>
                <span className="cart-item__total-price">${price}</span>
              </div>

              <span className="cart-item__total-old-price">${oldPrice}</span>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItemHeader;
